// Querys and Mutations
import {
  ALL_ACTIVE,
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE
} from '@/graphql/config/AdvanceTypesGraphql'

// models
import { ResponseDefault, Paginator } from '@/models'
import { AdvanceType, AdvanceTypeForm, AdvanceTypesWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class AdvanceTypesService {
    /**
     * Queries
     */
    async getActivated (): Promise<AdvanceType[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.advanceTypesActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<AdvanceTypesWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.advanceTypesWithPagination.paginatorInfo
        const data: AdvanceType[] = result.data.advanceTypesWithPagination.data
        const response: AdvanceTypesWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
     async create (form: AdvanceTypeForm): Promise<AdvanceType> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createAdvanceType
    }

    async update (id: number, form: AdvanceTypeForm): Promise<AdvanceType> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateAdvanceType
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new AdvanceTypesService()
